<template>
  <Layout>
    <div class="card" style="min-height: 80vh">
      <div class="card-header">
        <h3 class="text-uppercase mb-0">{{ $t("t_query_configuration") }}</h3>
        <div class="text-end">
          <div class="btn-header">
            <button
              class="btn btn-soft-secondary btn-border me-2"
              @click="fn_showFormTimKiem()"
            >
              <i class="ri-search-line"></i>
              {{ $t("t-search") }}
            </button>
            <button
              class="btn btn-secondary btn-border"
              @click="fn_handle('create', null)"
            >
              <i class="ri-add-circle-line"></i>
              {{ $t("t-add") }}
            </button>
          </div>
        </div>
      </div>
      <div class="card-body" style="padding: 0 0 15px 0">
        <div class="main-body">
          <div class="main-body-search mx-3 mb-3">
            <b-collapse
              v-model="tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card>
                <el-form
                  label-position="left"
                  ref="ruleFormRef"
                  @submit.prevent
                  :rules="rulesForm"
                  :model="tableRules.dataSearch.value"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item :label="$t('t_query_configuration_user')">
                        <el-select
                          v-model="tableRules.dataSearch.value['user_id']"
                          filterable
                          clearable
                          :placeholder="$t('t_query_configuration_select_user')"
                          style="width: 100%"
                          size="large"
                        >
                          <el-option
                            v-for="item in usersList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item :label="$t('t_query_configuration_limit')">
                        <el-input
                          clearable
                          v-model="tableRules.dataSearch.value['limit']"
                          :placeholder="
                            $t('t_query_configuration_limit_placeholder')
                          "
                          size="large"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <a
                        class="btn btn-soft-secondary btn-border waves-effect waves-light mx-3"
                        style="width: 80px"
                        @click="fn_showFormTimKiem()"
                      >
                        {{ $t("t-hide") }}
                      </a>
                      <button
                        class="btn btn-secondary bg-gradient btn-border waves-effect waves-light"
                        style="width: 100px"
                        native-type="submit"
                        @click="fn_TimKiem()"
                      >
                        {{ $t("t-search") }}
                      </button>
                    </b-col>
                  </b-row>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="mb-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <el-table
            size="small"
            :data="dataTables.value"
            style="width: 100%"
            max-height="550"
            v-loading="loading"
            @sort-change="fn_tableSortChange"
            :default-sort="{
              prop: tableRules.defaultSort[0],
              order: tableRules.defaultSort[1],
            }"
          >
            <el-table-column
              prop=""
              :label="$t('t-stt')"
              width="70"
              align="center"
            >
              <template #default="scope">
                <div class="text-center">
                  {{ tableRules.offset + scope.$index + 1 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="user"
              :label="$t('t_query_configuration_user')"
              min-width="200"
              :sortable="true"
            />
            <el-table-column
              prop="limit"
              :label="$t('t_query_configuration_limit')"
              min-width="200"
              :sortable="true"
            />
            <el-table-column
              :label="$t('t-action')"
              align="center"
              width="150px"
            >
              <template #default="scope">
                <div class="btn-group-thao-tac">
                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_option')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-success waves-effect waves-light btn-sm"
                      @click="fn_handle('update', scope.row)"
                    >
                      <i class="ri-edit-box-line"></i>
                    </button>
                  </el-tooltip>

                  <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="$t('action_delete')"
                    placement="left"
                  >
                    <button
                      type="button"
                      class="btn btn-soft-danger waves-effect waves-light btn-sm"
                      @click="fn_handle('delete', scope.row)"
                    >
                      <i class="ri-delete-bin-6-line"></i>
                    </button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="mt-3" style="float: right">
            <el-pagination
              small
              v-model:currentPage="tableRules.page"
              v-model:pageSize="pageSizeDefault"
              :page-sizes="tableRules.lengthMenu"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableRules.total"
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
            />
          </div>
          <maxRequestConfig />
        </div>
      </div>
      <dialog-cau-hinh-truy-van
        ref="queryConfigFormRef"
        @success="handleFormSuccess"
      />
    </div>
  </Layout>
</template>

<script setup>
import Layout from "../../layouts/main.vue";
import { onMounted, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import MethodService from "../../service/MethodService";
import Swal from "sweetalert2";
import toastr from "toastr";
import DataForm from "./dataCauHinhTruyVan";
import mushroom from "cem-primary-api";
import { Filter } from "mushroomjs";
import DialogCauHinhTruyVan from "./dialog-request-config.vue";
import maxRequestConfig from "./max-request-config.vue";

import { useI18n } from "vue-i18n";
const { t } = useI18n();
const queryConfigFormRef = ref(null);
let loading = ref(true);
const router = useRouter();
const route = useRoute();
const tableRules = reactive(MethodService.copyObject(DataForm.tableRules));
const dataTables = reactive({ value: [] });
const pageSizeDefault = ref(20);
const usersList = ref([]); // danh sách người dùng
const fn_handle = (type, row) => {
  if (type === "create") {
    queryConfigFormRef.value.open({
      typeFormProps: "createForm",
      dataRowProps: null,
      usersListProps: usersList.value,
    });
  }
  if (type === "update") {
    queryConfigFormRef.value.open({
      typeFormProps: "updateForm",
      dataRowProps: row,
      usersListProps: usersList.value,
    });
  }
  if (type === "delete") {
    Swal.fire({
      title: t("swal_noti"),
      text: t("t_query_configuration_noti_delete"),
      icon: "warning",
      confirmButtonColor: "#f46a6a",
      confirmButtonText: t("swal_accept"),
      cancelButtonText: t("swal_cancel"),
      showCancelButton: true,
      allowOutsideClick: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await mushroom.api_request_limit.deleteAsync({
            id: row.id,
          });
          if (response.result) {
            toastr.success(t("t_query_configuration_noti_delete_success"));
            fetchApiRequestLimit();
          }
        } catch (e) {
          console.error("Có lỗi: %o", e);
          MethodService.showError(e.code);
        }
      }
    });
  }
};
const fn_showFormTimKiem = () => {
  tableRules.showFormSearch = !tableRules.showFormSearch;
  router
    .replace(MethodService.routerReplace("DanhSachCauHinhTruyVan", tableRules))
    .catch(() => {});
};
const fn_TimKiem = () => {
  if (tableRules.dataSearch.value["limit"]) {
    tableRules.dataSearch.value["limit"] =
      tableRules.dataSearch.value["limit"].trim();
  }
  tableRules.filters = MethodService.filterTable(
    JSON.stringify(tableRules.dataSearch)
  );
  tableRules.offset = 0;
  tableRules.sort = "";
  fetchApiRequestLimit();
};
const fn_tableSizeChange = (limit) => {
  tableRules.limit = limit;
  pageSizeDefault.value = limit;
  fn_tableChangeOffset(tableRules.page);
};
const fn_tableCurentChange = (page) => {
  fn_tableChangeOffset(page);
};
const fn_tablePrevClick = (page) => {
  fn_tableChangeOffset(page - 1);
};
const fn_tableNextClick = (page) => {
  fn_tableChangeOffset(page + 1);
};
const fn_tableChangeOffset = (page) => {
  tableRules.page = page;
  tableRules.offset = (tableRules.page - 1) * pageSizeDefault.value;
  fetchApiRequestLimit();
};
const fn_tableSortChange = (column) => {
  MethodService.tableSortChange(column, tableRules);
  loading.value = true;
  fetchApiRequestLimit();
};
const fn_hashUrl = () => {
  MethodService.hashUrl(route.query, tableRules);
  pageSizeDefault.value = tableRules.limit;
};

const changeData = async (data) => {
  const userIds = data.map((item) => item.user_id);
  const { result } = await mushroom.user.listAsync({
    filters: Filter.in("id", userIds).build(),
    fields: "id,account",
    limit: userIds.length,
  });
  const usersMap = {};
  result.forEach((user) => {
    usersMap[user.id] = user.account;
  });
  return data.map((item) => ({
    ...item,
    user: usersMap[item.user_id] || "",
  }));
};
const fetchApiRequestLimit = async () => {
  let dataFilter = {
    filters: tableRules.filters,
    fields: tableRules.fields,
    limit: tableRules.limit,
    offset: tableRules.offset,
    sort: tableRules.sort,
  };
  router
    .replace(MethodService.routerReplace("DanhSachCauHinhTruyVan", tableRules))
    .catch(() => {});
  try {
    const response = await mushroom.api_request_limit.listAsync(dataFilter);
    if (response.result) {
      dataTables.value = await changeData(response.result);
      tableRules.total = response.meta.total;
      tableRules.page = response.meta.offset / response.meta.limit + 1;
    }
  } catch (e) {
    MethodService.showError(e.code);
  } finally {
    loading.value = false;
  }
};
const fetchAllUsers = async () => {
  try {
    const { result } = await mushroom.user.getAllAsync({
      filters: Filter.in("roles", ["QueryAPI"]).build(),
    });
    usersList.value = result.map((user) => ({
      label: user.account,
      value: user.id,
    }));
  } catch (e) {
    console.error("Có lỗi: %o", e);
    MethodService.showError(e.code);
  }
};
const handleFormSuccess = async () => {
  await fetchApiRequestLimit();
};

onMounted(async () => {
  fn_hashUrl();
  await fetchAllUsers();
  await fetchApiRequestLimit();
});
</script>
<style scoped lang="scss">
.max-request {
  float: left;
  display: flex;
  align-items: center;
  margin: 16px 20px;
  p {
    margin: 0;
    margin-right: 10px;
  }
}
.max-request_input {
  display: flex;
  align-items: center;
}
.max-request_input .el-input-number {
  margin-right: 10px;
}
</style>
